import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReajusteAutomaticoContratoService {

  constructor(private readonly http: HttpClient) { }

  public getReadjustmentBanner(idEmpresa: any) {    
    return this.http.get(`/apiconnect/auto-readjustment/contract_readjustment/showReadjustmentBanner?idCompany=${idEmpresa}`, { responseType: 'text' });
  }

  public putReadjustmentBanner(idEmpresa: any) {    
    return this.http.put(`/apiconnect/auto-readjustment/contract_readjustment/showReadjustmentBanner?idCompany=${idEmpresa}`, {});
  }
}
